enum ActionTypes {
    SAVE_ORGANIZATIONS = "SAVE_ORGANIZATIONS",
    SET_ACTIVE_ORGANIZATION = "SET_ACTIVE_ORGANIZATION",
    LOADING_ORGANIZATIONS = "LOADING_ORGANIZATIONS",
    LOADING_ORG_MEMBERS = "LOADING_ORG_MEMBERS",
    LOGOUT_ACTION = "LOGOUT_ACTION",
}

export default ActionTypes;
